import { ComponentNotificationBodyTaskTitleAndDescription } from "@fixa/notifications";
import TaskNotificationPriority from "../TaskNotificationPriority";
import TaskNotificationStatus from "../TaskNotificationStatus";
import styles from "../task-notification.module.css";
import TaskNotificationSafety from "../TaskNotificationSafety";
import { useNotificationString } from "../hooks/useNotificationString";

interface TaskNotificationBodyTitleAndDescriptionProps extends ComponentNotificationBodyTaskTitleAndDescription {
  read: boolean;
}
const TaskNotificationBodyTitleAndDescription = ({
  props: { priority, safety, status, title, description },
}: TaskNotificationBodyTitleAndDescriptionProps) => {
  const titleString = useNotificationString(title);
  return (
    <div className={styles["task-notification-item-body"] ?? ""}>
      <div className={styles["task-notification-item-body-texts"] ?? ""}>
        {priority && <TaskNotificationPriority />}
        {safety && <TaskNotificationSafety />}
        {!!titleString && (
          <div className={styles["task-notification-item-body-title"] ?? ""}>
            {titleString}
          </div>
        )}
        {!!description && <div>{description}</div>}
      </div>
      {(status === "completed" || status === "closed") && (
        <TaskNotificationStatus status={status} />
      )}
    </div>
  );
};

export default TaskNotificationBodyTitleAndDescription;
